<div *ngIf="service" class="pagebreak ml-5 mr-5">
    <div class="row mt-2" *ngIf="service.name" style="margin-bottom:-15px">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'SERVICE-NAME' | translate }}</label>
        </div>
        <div class="col-5">
            <p [innerHTML]="service.name"></p>
        </div>
        <div class="col-3" *ngIf="reportImageUrl">
            <img class="header-logo-client-image float-right" [src]="reportImageUrl">
        </div>
    </div>
    <div class="row" *ngIf="service.organization" style="margin-bottom:-15px">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'BY' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.organization.name"></p>
        </div>
    </div>
    <hr />
    <div class="row" *ngIf="service.formattedAddress !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ADDRESS' | translate }}</label>
        </div>
        <div class="col-8">
            <a *ngIf="showMap" class="d-flex" href="{{mapUrl + service.formattedAddress}}" target="_blank">
                <i class="fa fa-ap-marker-alt"></i>
                <span>{{service.formattedAddress}}</span>
            </a>
            <span *ngIf="!showMap">{{service.formattedAddress}}</span>
        </div>
    </div>
    <div class="row" *ngIf="service.distance > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DISTANCE' | translate }}</label>
        </div>
        <div class="col-8">
            {{service.distance | number: '1.2-2'}} {{formatDistanceLabel(service.distance)}}
        </div>
    </div>
    <div class="row" *ngIf="service.resourceStatus !== null && service.resourceStatus !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'RESOURCE-STATUS' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.resourceStatus.displayName | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.openingTimes !== null && service.openingTimes.length > 0"
        [ngClass]="{'mb-3': service.openingTimes.length > 1}">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'OPENED-ON' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngFor="let hour of service.openingTimes;">
                <div class="col-3" style="max-width: 120px;">
                    <span>{{hour.day}}</span>
                </div>
                <div class="col-9">
                    <span class="text-lowercase">{{hour.fromDate | date:'h:mm a'}}
                        -
                        {{hour.toDate | date:'h:mm a'}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="service.waitTimes !== null && service.waitTimes.length > 0"
        [ngClass]="{'mb-3': service.waitTimes.length > 1}">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'WAIT-TIMES' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngFor="let waitTime of service.waitTimes;">
                <div class="col-12"><span
                        *ngIf="waitTime.locationID">{{waitTime.locationID}}&nbsp;-&nbsp;</span>{{waitTime.waitTime}}
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="service.description && service.description !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DESCRIPTION' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.description | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.alias !== null && service.alias !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ALIAS' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.alias | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.eligibility && service.eligibility !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ELIGIBILITY' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.eligibility | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.cost && service.cost !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'COST' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.cost | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.websites !== null && service.websites.length > 0"
        [ngClass]="{'mb-3': service.websites.length > 1}">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'WEBSITES' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngFor="let website of service.websites;">
                <div class="col-12"><span *ngIf="website.name">{{website.name}}&nbsp;-&nbsp;</span>
                    <a *ngIf="website.url" href="{{website.url}}" title="{{website.url}}" target="_blank">
                        {{website.url}}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!--Program Contact-->
    <div class="row mb-3" *ngIf="(service.programContactName !== null && service.programContactName !== '') ||
            (service.email !== null && service.email !== '') ||
            (service.phoneNumber !== null && service.phoneNumber !== '') ||
            (service.url !== null && service.url !== '') ||
            (service.faxNumber !== null && service.faxNumber !== '')">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'PROGRAM-CONTACT' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngIf="service.programContactName !== null && service.programContactName !== ''">
                <div class="col-12">
                    {{service.programContactName}}
                </div>
            </div>
            <div class="row" *ngIf="service.email !== null && service.email !== ''">
                <div class="col-12">
                    <a href="mailto:{{service.email}}" target="_blank">
                        {{service.email}}
                    </a>
                </div>
            </div>
            <div class="row" *ngIf="service.phoneNumber !== null && service.phoneNumber !==''">
                <div class="col-12">
                    <i class="fas fa-phone"></i>&nbsp;{{service.phoneNumber | phone}}
                </div>
            </div>
            <div class="row" *ngIf="service.faxNumber !== null && service.faxNumber !==''">
                <div class="col-12">
                    <i class="fas fa-fax"></i>&nbsp;{{service.faxNumber | phone}}
                </div>
            </div>
            <div class="row" *ngIf="service.url !== null && service.url !==''">
                <div class="col-12">
                    <i class="fas fa-link"></i>&nbsp;
                    <a href="{{service.url}}" title="{{service.url}}" target="_blank">
                        {{service.url}}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!--Referral Contact-->
    <div class="row mb-3" *ngIf="(service.referralContactName !== null && service.referralContactName !== '') ||
                (service.referralEmail !== null && service.referralEmail !== '') ||
                (service.referralPhoneNumber !== null && service.referralPhoneNumber !=='') ||
                (service.referralUrl !== null && service.referralUrl !== '') ||
                (service.referralFaxNumber !== null && service.referralFaxNumber !=='') ||
                (service.referralEmergencyNumber !== null && service.referralEmergencyNumber !== '') ||
                (service.referralExtension !== null && service.referralExtension !== '')">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'REFERRAL-CONTACT' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngIf="service.referralContactName !== null && service.referralContactName !== ''">
                <div class="col-12">
                    {{service.referralContactName}}
                </div>
            </div>
            <div class="row" *ngIf="service.referralEmail !== null && service.referralEmail !== ''">
                <div class="col-12">
                    <a href="mailto:{{service.referralEmail}}" target="_blank">
                        {{service.referralEmail}}
                    </a>
                </div>
            </div>
            <div class="row" *ngIf="service.referralPhoneNumber !== null && service.referralPhoneNumber !==''">
                <div class="col-12">
                    <i class="fas fa-phone"></i>&nbsp;{{service.referralPhoneNumber | phone}}
                </div>
            </div>
            <div class="row" *ngIf="service.referralExtension !== null && service.referralExtension !==''">
                <div class="col-12">
                    <i class="fas fa-phone"></i>&nbsp;{{
                    'PHONE-EXTENSION-PREFIX' | translate
                    }}&nbsp;{{service.referralExtension | phone}}
                </div>
            </div>
            <div class="row" *ngIf="service.referralEmergencyNumber !== null && service.referralEmergencyNumber !==''">
                <div class="col-12">
                    <i class="fas fa-phone"></i>&nbsp;{{service.referralEmergencyNumber | phone}}&nbsp;({{
                    'EMERGENCY-CONTACT' | translate
                    }})
                </div>
            </div>
            <div class="row" *ngIf="service.referralFaxNumber !== null && service.referralFaxNumber !==''">
                <div class="col-12">
                    <i class="fas fa-phone"></i>&nbsp;{{service.referralFaxNumber | phone}}
                </div>
            </div>
            <div class="row" *ngIf="service.referralUrl !== null && service.referralUrl !==''">
                <div class="col-12">
                    <i class="fas fa-link"></i>&nbsp;
                    <a href="{{service.referralUrl}}" title="{{service.referralUrl}}" target="_blank">
                        {{service.referralUrl}}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="service.languages !== null && service.languages.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'LANGUAGES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let language of service.languages; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{language.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.alertDescription !== null && service.alertDescription !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ALERT-DESCRIPTION' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.alertDescription | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.applicationProcess !== null && service.applicationProcess !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'APPLICATION-PROCESS' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.applicationProcess | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.capacity !== null && service.capacity !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'CAPACITY' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.capacity | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.documentationRequired !== null && service.documentationRequired !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DOCUMENTATION-REQUIRED' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.documentationRequired | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.acceptingDisabledPatients !== null && service.acceptingDisabledPatients !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{'ACCEPTING-DISABLED-PATIENTS' | translate:patientLabel}}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.acceptingDisabledPatients">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.acceptingDisabledPatients">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row"
        *ngIf="service.acceptingElectronicReferrals !== null && service.acceptingElectronicReferrals !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ACCEPTING-ELECTRONIC-REFERRALS' | translate }}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.acceptingElectronicReferrals">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.acceptingElectronicReferrals">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row" *ngIf="service.acceptingNewPatients !== null && service.acceptingNewPatients !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{'ACCEPTING-NEW-PATIENTS' | translate:patientLabel}}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.acceptingNewPatients">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.acceptingNewPatients">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row" *ngIf="service.acceptingSelfReferrals !== null && service.acceptingSelfReferrals !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ACCEPTING-SELF-REFERRALS' | translate }}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.acceptingSelfReferrals">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.acceptingSelfReferrals">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row" *ngIf="service.lgbtq !== null && service.lgbtq !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'LGBTQ' | translate }}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.lgbtq">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.lgbtq">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row"
        *ngIf="service.submittingOrganization !== null && service.submittingOrganization.name !== null && service.submittingOrganization.name !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'SUBMITTING-ORGANIZATION' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.submittingOrganization.name | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.areaServedCities !== null && service.areaServedCities.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'AREAS-SERVED-CITIES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let areaServedCity of service.areaServedCities; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{areaServedCity.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.areaServedCounties !== null && service.areaServedCounties.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'AREAS-SERVED-COUNTIES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let areaServedCounty of service.areaServedCounties; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{areaServedCounty.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.areaServedZipCodes !== null && service.areaServedZipCodes.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'AREAS-SERVED-ZIPCODES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let areaServedZipCode of service.areaServedZipCodes; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{areaServedZipCode.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.incomeRequirements !== null && service.incomeRequirements.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'INCOME-REQUIREMENTS' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let incomeRequirement of service.incomeRequirements; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{incomeRequirement.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.paymentMethods !== null && service.paymentMethods.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'PAYMENT-METHODS' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let paymentMethod of service.paymentMethods; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{paymentMethod.displayName}}</span>
            </p>
        </div>
    </div>
    <!--2023-03-10 PR: Don't make sense to show identifiers
    <div class="row" *ngIf="service.otherIdentifiers !== null && service.otherIdentifiers.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'OTHER-IDENTIFIERS' | translate }}</label>
        </div>
        <div class="col-8">
            <div class="row" *ngFor="let ident of service.otherIdentifiers;">
                <div class="col-12">{{ident.isoassigningAuthority}} {{ident.numberValue}} {{ident.numberType}}
                    {{ident.numberTypeCodeSystem}}</div>
            </div>
        </div>
    </div>-->
    <div class="row" *ngIf="service.licenses !== null && service.licenses.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'LICENSES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let license of service.licenses; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{license.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.targetedPopulations !== null && service.targetedPopulations.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'TARGETED-POPULATIONS' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let targetedPopulation of service.targetedPopulations; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{targetedPopulation.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.targetedDemographics !== null && service.targetedDemographics.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'TARGETED-DEMOGRAPHICS' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let targetedDemographic of service.targetedDemographics; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{targetedDemographic.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.providerTaxonomies !== null && service.providerTaxonomies.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'TAXONOMIES' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let providerTaxonomy of service.providerTaxonomies; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{providerTaxonomy.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.directoryManagerName !== null && service.directoryManagerName !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DIRECTORY-MANAGER-NAME' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.directoryManagerName | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.directoryManagerEmail !== null && service.directoryManagerEmail !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DIRECTORY-MANAGER-EMAIL' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="service.directoryManagerEmail | replaceLineBreaks"></p>
        </div>
    </div>
    <div class="row"
        *ngIf="service.directoryManagerNotificationPreference !== null && service.directoryManagerNotificationPreference !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'DIRECTORY-MANAGER-NOTIFICATION-PREFERENCE' | translate }}</label>
        </div>
        <div class="col-8">
            <p [innerHTML]="getNotificationPreference(service.directoryManagerNotificationPreference)"></p>
        </div>
    </div>
    <div class="row" *ngIf="service.languenhancedServicesages !== null && service.enhancedServices.length > 0">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ENHANCED-SERVICES-OFFERED' | translate }}</label>
        </div>
        <div class="col-8">
            <p>
                <span *ngFor="let enhancedService of service.enhancedServices; let i=index;">
                    <span *ngIf="i > 0">,&nbsp;</span>{{enhancedService.displayName}}</span>
            </p>
        </div>
    </div>
    <div class="row" *ngIf="service.ableToConductScreenings !== null && service.ableToConductScreenings !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'ABLE-TO-CONDUCT-SCREENINGS' | translate }}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.ableToConductScreenings">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.ableToConductScreenings">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row" *ngIf="service.informationalOnly !== null && service.informationalOnly !== ''">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'INFORMATIONAL-ONLY' | translate }}</label>
        </div>
        <div class="col-8">
            <span *ngIf="service.informationalOnly">{{ 'YES' | translate }}</span>
            <span *ngIf="!service.informationalOnly">{{ 'NO' | translate }}</span>
        </div>
    </div>
    <div class="row">
        <div class="col-4 text-right">
            <label class="service-label">{{ 'LAST-UPDATED' | translate }}</label>
        </div>
        <div class="col-8">
            <span>{{service.lastModifiedOn | date:'longDate' }}</span>
        </div>
    </div>
    <div class="row mb-3 no-print" *ngIf="service.directoryManagerEmail && service.directoryManagerName">
        <div class="col-4"></div>
        <div class="col-8">
            <a class="pointer" target="_blank"
                (click)="showServiceCorrectionDialog=true;">{{'REPORT-INCORRECT-INFORMATION' | translate}}<i
                    class="fa fa-external-link ml-1"></i>
            </a>
        </div>
    </div>
</div>

<!--Report Incorrect Info form-->
<app-community-service-correction *ngIf="showServiceCorrectionDialog" [serviceId]="service.id"
    [serviceName]="service.name" [serviceAddress]="service.formattedAddress"
    [managerEmail]="service.directoryManagerEmail" [managerName]="service.directoryManagerName"
    [managerNotificationPreference]="service.directoryManagerNotificationPreference"
    (cancelling)="showServiceCorrectionDialog=false;">
</app-community-service-correction>